export enum ContentType {
    FilterContent = 'Filter', // = 0,
    TrouserFinderContent = 'ESPP1-TrouserFinderWeb',
    JacketFinderContent = 'ESPP1-JacketFinderWeb',
    ShoeFinderContent = 'ESPP1-ShoeFinderWeb',
    SortContent = 'Sort',
}
